// src/components/ui/forms/ValidationMessage/ValidationMessageShadcn.jsx
import React from 'react';
import { AlertTriangle, CheckCircle2, Info, X } from 'lucide-react';

// shadcn components
import { Alert, AlertDescription } from '../../alert';
import { Button } from '../../button';

import { cn } from '../../../../utils/cn';

const ValidationMessageShadcn = ({
  type = 'error', // 'error', 'success', 'warning', 'info'
  message,
  dismissible = false,
  onDismiss,
  className = '',
  ...props
}) => {
  // Type configurations extracted from old EventCreationPanel patterns
  const typeConfig = {
    error: {
      icon: AlertTriangle,
      container: 'bg-red-500/10 border-red-500/20',
      iconBg: 'bg-red-500/20',
      iconColor: 'text-red-400',
      textColor: 'text-red-200'
    },
    success: {
      icon: CheckCircle2,
      container: 'bg-emerald-500/10 border-emerald-500/20',
      iconBg: 'bg-emerald-500/20',
      iconColor: 'text-emerald-400',
      textColor: 'text-emerald-200'
    },
    warning: {
      icon: AlertTriangle,
      container: 'bg-amber-500/10 border-amber-500/20',
      iconBg: 'bg-amber-500/20',
      iconColor: 'text-amber-400',
      textColor: 'text-amber-200'
    },
    info: {
      icon: Info,
      container: 'bg-blue-500/10 border-blue-500/20',
      iconBg: 'bg-blue-500/20',
      iconColor: 'text-blue-400',
      textColor: 'text-blue-200'
    }
  };

  const config = typeConfig[type];
  const IconComponent = config.icon;

  if (!message) return null;

  return (
    <Alert
      className={cn(
        // Base styling extracted from old CustomerModal error display
        "flex items-center gap-3 p-4 rounded-xl backdrop-blur-sm",
        "border transition-all duration-200",
        config.container,
        className
      )}
      {...props}
    >
      {/* Icon */}
      <div className={cn(
        "flex items-center justify-center w-8 h-8 rounded-lg flex-shrink-0",
        config.iconBg
      )}>
        <IconComponent className={cn("w-4 h-4", config.iconColor)} />
      </div>

      {/* Message */}
      <AlertDescription className={cn("font-medium flex-1", config.textColor)}>
        {message}
      </AlertDescription>

      {/* Dismiss button */}
      {dismissible && onDismiss && (
        <Button
          variant="ghost"
          onClick={onDismiss}
          className={cn(
            "flex items-center justify-center w-6 h-6 rounded p-0 h-auto",
            "hover:bg-slate-700/50 transition-colors",
            config.iconColor
          )}
          title="Dismiss"
        >
          <X className="w-4 h-4" />
        </Button>
      )}
    </Alert>
  );
};

export default ValidationMessageShadcn;